<template>
  <div class="about">
    <div><p style="text-align: right;">{{shop}}</p></div>
    <h1>FAQs</h1>
    <section>
      <div class="faq-container">
        <div class="question">
          <h4>Setup Guide and FAQ</h4>
          <div class="content"><a target="_blank" href="https://www.notion.so/inscoder/Connected-Inventory-Help-Center-b9f6f01d950b4a5288f1997df350c874">Go to our support portal</a></div>
        </div>
      </div>
      <div class="faq-container">
        <div class="question">
          <h4>Contact us</h4>
          <div class="content">If you have any query, please contact us at <a href="mailto:support@inscoder.com">support@inscoder.com</a></div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

export default {
  computed: {
    count () {
      return this.$store.state.count
    }
  },
  created: function () {

  },
  data () {
    return {
      shop: this.$store.state.shop,
      info: null,
      loading: true,
      faqs: [
        {
          title: 'HOW IS THIS APP WORKS?',
          content: 'First, you need to connect the products manually or choose to connect by SKU automatically. When customer placed an order, we will reduce the quantity from all the connected products/variants.'
        },
        {
          title: 'WHY THE APP FAIL TO SYNCHROIZE NEW PRODUCTS EVEN I USE THE SAME SKU?',
          content: 'In <strong>auto-connect SKU</strong> mode: Everytime you add a new product or change the SKU, it is required to refresh SKU in this app. Click <strong>Refresh SKU</strong>. <br>In <strong>manual</strong> mode: You need to add product to the specific group manually.'
        },
        {
          title: 'WHY THE INVENTORY DOES NOT UPDATE AFTER I CHANGE PRODUCT/VARIANT QUANTITY IN ADMIN PAGE?',
          content: 'It is expected, updating via admin page will not synchronize to other product. Instead, you can make use of the <strong>Edit Inventory</strong> feature to update all conected inventory in one go.'
        }
      ],
    }
  },
  filters: {
    currencydecimal (value) {
      return value.toFixed(2)
    }
  },
  mounted () {

  }

}
</script>
